document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".cmp-container").forEach((container) => {
    const overlay = container.querySelector(".cmp-overlay");
    const handle = container.querySelector(".cmp-handle");
    let dragging = false;

    // 1) Intersection to add .is-visible once
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          container.classList.add("is-visible");
          io.disconnect();
        }
      },
      { threshold: 0.5 }
    );
    io.observe(container);

    // 2) Drag logic (unchanged)
    const start = (e) => {
      dragging = true;
      handle.classList.add("draggable");
      e.preventDefault();
    };
    const stop = () => {
      dragging = false;
      handle.classList.remove("draggable");
    };
    const move = (e) => {
      if (!dragging) return;
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const rect = container.getBoundingClientRect();
      let x = clientX - rect.left;
      x = Math.max(0, Math.min(rect.width, x));
      const pct = (x / rect.width) * 100;
      handle.style.left = `${Math.min(99.5, pct)}%`;
      overlay.style.width = `${pct}%`;
    };

    handle.addEventListener("mousedown", start);
    handle.addEventListener("touchstart", start);
    document.addEventListener("mouseup", stop);
    document.addEventListener("touchend", stop);
    document.addEventListener("mousemove", move);
    document.addEventListener("touchmove", move);
  });
});
